export class PlantIdRequest{
    plantId: number;
    role?: string;

}